/** How a survey states a duration: two figures side by side must never be cut differently. */
type Translate = (key: string, options?: Record<string, unknown>) => string;

const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;

const hoursAndMinutes = (seconds: number, t: Translate) => {
    const hours = Math.floor(seconds / SECONDS_PER_HOUR);
    const minutes = Math.floor((seconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);

    return minutes ? t('{{hours}}h {{minutes}}m', {hours, minutes}) : t('{{hours}}h', {hours});
};

const normalize = (seconds: number) => Math.max(0, Math.round(seconds));

const minutesAndSeconds = (total: number, t: Translate) => {
    const minutes = Math.floor(total / SECONDS_PER_MINUTE);
    const rest = total % SECONDS_PER_MINUTE;

    return rest ? t('{{minutes}}m {{seconds}}s', {minutes, seconds: rest}) : t('{{minutes}}m', {minutes});
};

export const formatSurveyFillOutTime = (seconds: number, t: Translate): string => {
    const total = normalize(seconds);
    if (total < SECONDS_PER_MINUTE) return t('{{seconds}}s', {seconds: total});
    if (total < SECONDS_PER_HOUR) return minutesAndSeconds(total, t);

    return hoursAndMinutes(total, t);
};

export const formatSurveyTimeToRespond = (seconds: number, t: Translate): string => {
    const total = normalize(seconds);
    if (total < SECONDS_PER_MINUTE) return t('{{seconds}}s', {seconds: total});

    // Same shape as the fill-out time: two figures side by side must not be cut differently.
    if (total < SECONDS_PER_HOUR) return minutesAndSeconds(total, t);

    if (total < SECONDS_PER_DAY) return hoursAndMinutes(total, t);

    const days = Math.floor(total / SECONDS_PER_DAY);
    const hours = Math.floor((total % SECONDS_PER_DAY) / SECONDS_PER_HOUR);

    return hours ? t('{{days}}d {{hours}}h', {days, hours}) : t('{{days}}d', {days});
};
